import { Component, Input } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';

@Component({
  selector: 'app-form-dibattimento-view',
  templateUrl: './form-dibattimento-view.component.html',
  styleUrls: ['./form-dibattimento-view.component.css']
})
export class FormDibattimentoViewComponent {
  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;

  @Input() ctxBodyFascicolo;
  constructor() {}
}
